import React from "react";

import { HStack, Text } from "../ui";

interface StatusInfoProps {
  avatarSize: number;
  icon: React.ReactNode;
  text: React.ReactNode;
}

const StatusInfo = (props: StatusInfoProps) => {
  const { avatarSize, icon, text } = props;

  const onClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
  };

  return (
    <div role="status-info" onClick={onClick}>
      <HStack
        space={3}
        alignItems="center"
        className="cursor-default text-muted-foreground rtl:space-x-reverse"
      >
        <div className="flex justify-end" style={{ width: avatarSize }}>
          {icon}
        </div>

        <Text size="xs" theme="muted" weight="medium">
          {text}
        </Text>
      </HStack>
    </div>
  );
};

export default StatusInfo;
